import Vue from "vue"
import Vuex from "vuex"
import api from "../api"
import moment from "moment"
import * as types from "./mutation-types"

Vue.use(Vuex)

const handle_response_meta = (commit, response) => {
    if(response && response.meta) {
        if(response.meta.updates) {
            Object.keys(response.meta.updates).forEach(updated_entity => {
                const updated_records = response.meta.updates[updated_entity]
                commit(types.SET_RECORDS, { entity: updated_entity, records: updated_records.data || updated_records })
            })
        }
        if(response.meta.holidays) commit(types.SET_HOLIDAYS, { records: response.meta.holidays })
    }
    if(response && response.app_context) {
        commit(types.SET_APP_CONTEXT, { app_context: response.app_context })
    }
}
const handle_error = (error, commit) => {
    const status = is_access_denied_error(error)
    if(status === 401) commit(types.SET_PROFILE, { profile: null })
    else throw standard_error(error)
}
const is_access_denied_error = (error) => {
    if(error) {
        let status = error.status
        if(error.response && error.response.status) status = error.response.status
        if((status === 401) || (status === 403)) return status
    }
    return 200
}
const standard_error = (call_results, raw) => {
    const result = {
        error: {
            header: "",
            message: "",
            number: 0
        }
    }

    if(call_results) {
        if(call_results.response && call_results.response.data && call_results.response.data.response_data && call_results.response.data.response_data.error) {
            result.error.message = call_results.response.data.response_data.error
        } else if(call_results.data && call_results.data.response_data && call_results.data.response_data.error) {
            result.error = call_results.data.response_data.error
        } else if(call_results.data && call_results.data.response_data && call_results.data.response_data.message) {
            result.error.message = call_results.data.response_data.message
        } else if(call_results.error) {
            result.error.message = call_results.error
        } else if(call_results.message) {
            result.error.message = call_results.message
        } else if(call_results.response_data && call_results.response_data.message) {
            result.error.message = call_results.response_data.message
        } else if(call_results.data && call_results.data.error) {
            result.error = call_results.data.error
        } else {
            result.error = call_results.data || call_results
        }
        if(typeof result.error === "string") {
            result.error = {
                header: window.nibnut.vue.translate("Ooops!"),
                message: result.error,
                number: 0
            }
        }

        if(call_results.status) result.error.number = call_results.status
        else if(call_results.error && call_results.error.number) result.error.number = call_results.error.number
        else if(call_results.number) result.error.number = call_results.number
    }

    return raw ? result : result.error
}
const handle_records_list_response = (response, entity, commit, passthru = false) => {
    const local_response = { total: 0, found: 0, record_ids: [], query_info: {} }

    const records = (response.data || response).map(record => record.data || record)
    if(!passthru) commit(types.SET_RECORDS, { entity, records })
    handle_response_meta(commit, response)

    if(passthru) local_response.records = records
    else local_response.record_ids = records.map(record => record.id)
    if(response.meta) {
        local_response.total = response.meta.total || 0
        local_response.found = response.meta.found || 0
        local_response.query_info = response.meta.query_info || {}
    }
    return local_response
}

const state = {
    lockdown: null,
    profile_id: null, // current logged-in user
    login_request: {
        panel_id: false,
        callback: null
    },
    confirming: false,
    confirmation_props: {},

    // this is our records cache records in here can be basic, or fully-loaded.
    records: {
        attachment: {/* { [id: number]: Attachment } */},
        dictionary: {/* { [id: number]: Dictionary } */},
        phase_template: {/* { [id: number]: Phase Template } */},
        term: {/* { [id: number]: Term } */},
        service: {/* { [id: number]: Service } */},
        category: {/* { [id: number]: Category } */},
        contact_method: {/* { [id: number]: ContactMethod } */},
        contact: {/* { [id: number]: Contact } */},
        address: {/* { [id: number]: Address } */},
        user: {/* { [id: number]: user } */},
        user_preference: {/* { [id: number]: userPreference } */},
        firm: {/* { [id: number]: Firm } */},
        project: {/* { [id: number]: Project } */},
        contact_project: {/* { [id: number]: Contact Project } */},
        comment: {/* { [id: number]: Comment } */},
        project_request: {/* { [id: number]: ProjectRequest } */},
        project_log: {/* { [id: number]: ProjectLog } */},
        project_sustainability_program: {/* { [id: number]: Project Sustainability Program } */},
        project_info: {/* { [id: number]: Project Info } */},
        account_credential: {/* { [id: number]: Account Credential } */},
        financial: {/* { [id: number]: Financial } */},
        project_expense: {/* { [id: number]: Project Expense } */},
        project_user: {/* { [id: number]: Project user } */},
        phase: {/* { [id: number]: Phase } */},
        billing_schedule_month: {/* { [id: number]: BillingScheduleMonth } */},
        task: {/* { [id: number]: Task } */},
        task_user: {/* { [id: number]: TaskUser } */},
        subtask: {/* { [id: number]: Subtask } */},
        subtask_user: {/* { [id: number]: SubtaskUser } */},
        proposal: {/* { [id: number]: Proposal } */},
        proposal_revision: {/* { [id: number]: Proposal Revision } */},
        firm_proposal_revision: {/* { [id: number]: Firm Proposal Revision } */},
        material_request: {/* { [id: number]: Material Request } */},
        qualification: {/* { [id: number]: Qualification } */},
        fee_estimate: {/* { [id: number]: Fee Estimate } */},
        fee_estimate_revision: {/* { [id: number]: Fee Estimate Revision } */},
        contract: {/* { [id: number]: Contract } */},
        contract_revision: {/* { [id: number]: Contract Revision } */},
        service_request: {/* { [id: number]: Service Request } */},
        service_request_revision: {/* { [id: number]: Service Request Revision } */},
        pro_photo: {/* { [id: number]: ProPhoto } */},
        award: {/* { [id: number]: Award } */},
        link: {/* { [id: number]: Link } */},
        alias: {/* { [id: number]: Alias } */},
        studio: {/* { [id: number]: Studio } */},
        time_off_request: {/* { [id: number]: TimeOffRequest } */},
        request_for_material: {/* { [id: number]: RequestForMaterial } */},
        report: {},
        delayed_notification: {},
        setting: {},
        notification_subscription: {},
        message: {}
    },

    context_states: {},
    graphs: {},
    dashboard_workload: [],
    holidays: [],

    system_message: {
        type: "primary", // primary, success, warning or error
        message: "",
        dismiss_after: 7000, // in milliseconds
        message_id: null
    },
    route_states: {},

    shells: {
        attachment: null,
        user: null,
        setting: null
    }
}

const getters = {
    route_state_by_identifier: (state) => (identifier) => {
        return state.route_states[identifier]
    },
    entity_records: (state) => (entity, ids = null) => {
        if(state.records[entity]) {
            if(!ids) return Object.values(state.records[entity])
            return ids.map(id => state.records[entity][id]).filter(record => !!record)
        }
        return []
    },
    entity_record: (state) => (entity, id) => {
        if(state.records[entity] && state.records[entity][id]) return state.records[entity][id]
        return null
    }
}

const actions = {
    EVALUATE_ONLINE_STATUS ({ state }) {
        state.offline = !navigator.onLine
    },

    CONFIRM ({ state }, { confirming, props }) {
        state.confirming = confirming
        state.confirmation_props = {
            type: "warning",
            icon: "exclamation-triangle",
            dismissable: false,
            title: "",
            message: "",
            cancel: "No",
            ok: "Yes",
            then: () => {},
            ...props
        }
    },
    REQUEST_LOGIN ({ state }, { panel_id = true, callback = null }) {
        state.login_request.panel_id = panel_id
        state.login_request.callback = callback
    },
    UNREQUEST_LOGIN ({ state }) {
        if(!!state.login_request && !!state.login_request.callback) state.login_request.callback()
        state.login_request.panel_id = false
        state.login_request.callback = null
    },
    SYSTEM_MESSAGE ({ state }, { message, type = "primary", dismiss_after = 7000, message_id = null }) {
        state.system_message.type = type
        state.system_message.message = message
        state.system_message.dismiss_after = dismiss_after
        state.system_message.message_id = message_id
    },
    SET_ROUTE_STATE: ({ commit }, { route, route_state }) => {
        commit(types.SET_ROUTE_STATE, { route, route_state })
    },
    JANITOR: ({ commit }, { entities }) => {
        entities.forEach(entity => {
            commit(types.UNSET_RECORDS, { entity })
        })
    },
    DUSTING: ({ commit }, { entity, record_id }) => {
        commit(types.UNSET_RECORD, { entity, record_id })
    },

    LOAD_PROFILE ({ state, commit }) {
        return api.load_profile().then(response => {
            commit(types.SET_PROFILE, { profile: response.data })
            handle_response_meta(commit, response)
        }).catch(error => {
            commit(types.SET_PROFILE, { profile: null })
            handle_response_meta(commit, error.data || error)
        })
    },
    LOGIN ({ commit, state }, { email, password }) {
        return api.login(email, password).then(response => {
            commit(types.SET_PROFILE, { profile: response.data })
            handle_response_meta(commit, response)
        }).catch(error => {
            commit(types.SET_PROFILE, { profile: null })
            throw standard_error(error)
        })
    },
    LOGOUT ({ commit, state }) {
        return api.logout().then(response => {
            commit(types.SET_PROFILE, { profile: null })
            handle_response_meta(commit, response)
        }).catch(error => {
            commit(types.SET_PROFILE, { profile: null })
            throw standard_error(error)
        })
    },
    SEND_PASSWORD_RESET ({ commit, state }, { email }) {
        return api.send_password_reset(email).then(response => {
            return response.data || response
        }).catch(error => {
            throw standard_error(error)
        })
    },
    SIGNUP ({ commit, state }, { data }) {
        return api.signup(data).then(response => {
            commit(types.SET_PROFILE, { profile: response.data })
            handle_response_meta(commit, response)
        }).catch(error => {
            commit(types.SET_PROFILE, { profile: null })
            throw standard_error(error)
        })
    },
    REINVITE ({ commit }, { email, expires_in }) {
        return api.reinvite(email, expires_in).then((response) => {
            if(response.data) commit(types.SET_RECORD, { entity: "user", record: response.data })
            handle_response_meta(commit, response)
            return response
        }).catch(error => {
            throw standard_error(error)
        })
    },
    LOAD_INVITATION ({ commit }, { token }) {
        return api.invitation(token).then((response) => {
            return response.data || response
        }).catch(error => {
            throw standard_error(error)
        })
    },
    RESET_PASSWORD ({ commit, state }, { token, email, password, password_confirmation }) {
        return api.reset_pasword(token, email, password, password_confirmation).then(response => {
            if(response && response.data && response.data.user) commit(types.SET_PROFILE, { profile: response.data.user })
            return response.data
        }).catch(error => {
            throw standard_error(error)
        })
    },
    TOGGLE_ADMIN_MODE ({ state, commit }) {
        return api.toggle_admin_mode().then(response => {
            commit(types.SET_PROFILE, { profile: response.data })
            handle_response_meta(commit, response)
        }).catch((error) => {
            throw standard_error(error)
        })
    },
    RECORDS_ACTION ({ state, commit }, { entity, action, data, method = "get", passthru = false }) {
        return api.records_action(entity, action, data, method).then(response => {
            return handle_records_list_response(response, entity, commit, passthru)
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    FETCH_RECORDS: ({ state, commit }, { entity, query, passthru = false }) => {
        return api.records(entity, query).then(response => {
            return handle_records_list_response(response, entity, commit, passthru)
        }).catch(error => {
            handle_error(error, commit)
        })
    },
    FETCH_RECORD: ({ state, commit }, { entity, id, query }) => {
        return api.record(entity, id, query).then(response => {
            if(state.profile_id) {
                commit(types.SET_RECORD, { entity, record: response.data })
                handle_response_meta(commit, response)
            }
            return response.data
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    FETCH_RECORD_SHELL: ({ state, commit }, { entity }) => {
        // if(state.shells[entity]) return Promise.resolve(state.shells[entity])

        return api.record_shell(entity).then(response => {
            commit(types.SET_RECORD_SHELL, { entity, shell: response.data })
            return response.data
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    CREATE_RECORD: ({ state, commit }, { entity, data }) => {
        return api.record_create(entity, data).then(response => {
            if(response) {
                if(response.data) commit(types.SET_RECORD, { entity, record: response.data })
                handle_response_meta(commit, response)
                return response.data
            }
        }).catch(error => {
            handle_error(error, commit)
        })
    },
    RECORD_SAVE ({ commit, state }, { entity, id, data }) {
        return api.record_save(entity, id, data).then(response => {
            if(response) {
                if(response.data) commit(types.SET_RECORD, { entity, record: response.data })
                handle_response_meta(commit, response)
                return response.data
            }
        }).catch(error => {
            handle_error(error, commit)
        })
    },
    RECORD_DELETE: ({ commit, state }, { entity, id, data }) => {
        return api.record_delete(entity, id, data).then((response) => {
            if(!response.data || !response.data.deleted_at) commit(types.UNSET_RECORD, { entity, record_id: id })
            else if(response.data) commit(types.SET_RECORD, { entity, record: response.data })
            if((entity === "user") && (id === state.profile_id)) commit(types.SET_PROFILE, { profile: null })
            handle_response_meta(commit, response)
            return response.data
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    RECORD_RESTORE: ({ commit, state }, { entity, id }) => {
        return api.record_restore(entity, id).then((response) => {
            if(response.data && !response.data.deleted_at) commit(types.SET_RECORD, { entity, record: response.data })
            handle_response_meta(commit, response)
            return response.data
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    RECORD_ACTION ({ state, commit }, { entity, id, action, data, passthru = false, method = "get" }) {
        return api.record_action(entity, id, action, data, method).then((response) => {
            if(response.data && !passthru) commit(types.SET_RECORD, { entity, record: response.data })
            handle_response_meta(commit, response)
            return response.data
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    FILE_ACTION ({ commit }, { entity, id, action, name, file, progress, data, method = "post" }) {
        return api.file_action(entity, id, action, name, file, progress, data, method).then((response) => {
            if(response.data) commit(types.SET_RECORD, { entity, record: response.data })
            handle_response_meta(commit, response)
            return response
        }).catch((error) => {
            handle_error(error, commit)
        })
    },

    DASHBOARD_DATA: ({ state, commit }, { entity, data_id }) => {
        return api.dashboard_data(data_id).then(response => {
            const data = response.data
            if(data_id === "holidays") commit(types.SET_HOLIDAYS, { records: data })
            if(data_id === "workload") commit(types.SET_DASHBOARD_WORKLOAD, { records: data })
            handle_response_meta(commit, response)
            return data
        }).catch((error) => {
            handle_error(error, commit)
        })
    },
    FETCH_REPORT: ({ state, commit }, { report_id, data }) => {
        return api.report_data(report_id, data).then(response => {
            if(response.data) {
                commit(types.SET_RECORD, {
                    entity: "report",
                    record: response.data
                })
            }
            handle_response_meta(commit, response)
            return response
        }).catch(error => {
            handle_error(error, commit)
        })
    },

    AUTOSUGGEST: ({ commit, state }, { entity = "dictionary", context, query }) => {
        return api.autosuggest(context, query, entity).then(response => {
            const records = response.data || []
            if((entity !== "dictionary") && !!state.records[entity]) commit(types.SET_RECORDS, { entity, records })
            handle_response_meta(commit, response)
            return records
        }).catch((error) => {
            handle_error(error, commit, true)
        })
    },
    AUTOSUGGEST_ADD: ({ commit, state }, { entity = "dictionary", context, data }) => {
        return api.autosuggest_add(entity, context, data).then(response => {
            return response.data // new choice object
        }).catch((error) => {
            handle_error(error, commit, true)
        })
    },
    CREATE_REQUESTS_FOR_MATERIAL ({ commit, state }, { id, data }) {
        return api.create_requests_for_material(id, data).then(response => {
            handle_response_meta(commit, response)
            return response.meta ? response.meta.updates : null
        }).catch((error) => {
            handle_error(error, commit, true)
        })
    },
    SAMPLE_RECORDS: ({ state, commit }, { entity, query }) => {
        return api.records(entity, query).then(response => {
            return response.data || response
        }).catch((error) => {
            handle_error(error, commit, true)
        })
    },
    EXPORT_RECORDS ({ commit, state }, { entity, query }) {
        return api.export_records(entity, query).then(response => {
            return response.data || response
        }).catch((error) => {
            handle_error(error, commit, true)
        })
    },
    DELETE_KEYWORD_SECTION: ({ commit, state }, { section }) => {
        return api.delete_keyword_section(section).then(response => {
            Object.values(state.records.category).forEach(category => {
                if(category.section === section) commit(types.UNSET_RECORD, { entity: "category", record_id: category.id })
            })
        }).catch((error) => {
            handle_error(error, commit, true)
        })
    }
}

const mutations = {
    [types.SET_APP_CONTEXT] (state, { app_context }) {
        Vue.set(state, "app_context", app_context || {})
    },
    [types.SET_ROUTE_STATE]: (state, { route, route_state }) => {
        Vue.set(state.route_states, route, route_state)
    },

    [types.SET_PROFILE] (state, { profile }) {
        if(profile) {
            mutations[types.SET_RECORD](state, { entity: "user", record: profile })
            state.profile_id = profile.id
        } else if(state.profile_id) {
            const user_id = state.profile_id
            state.profile_id = 0
            mutations[types.UNSET_RECORD](state, { entity: "user", record_id: user_id })
        }
    },

    [types.SET_RECORDS]: (state, { entity, records }) => {
        if(state.records[entity] && records) {
            records.forEach(record => {
                mutations[types.SET_RECORD](state, { entity, record })
            })
        }
    },
    [types.UNSET_RECORDS]: (state, { entity, ids = null }) => {
        if(state.records[entity]) {
            if(ids) {
                ids.forEach(id => {
                    mutations[types.UNSET_RECORD](state, { entity, record_id: id })
                })
            } else {
                let records = {}
                if((entity === "user") && !!state.profile_id) {
                    const profile = state.records.user[state.profile_id]
                    if(profile) records = { [profile.id]: profile }
                }
                if(!entity.match(/^(dictionary|term)$/i)) Vue.set(state.records, entity, records)
            }
        }
    },
    [types.SET_RECORD]: (state, { entity, record }) => {
        record = record.data || record
        const data = {
            ...(state.records[entity][record.id] || {}),
            ...record
        }
        Vue.set(state.records[entity], record.id, data)
    },
    [types.SET_RECORD_SHELL]: (state, { entity, shell }) => {
        Vue.set(state.shells, entity, shell)
    },
    [types.UNSET_RECORD]: (state, { entity, record_id }) => {
        if((entity === "user") && (record_id === state.profile_id)) return // Never remove current user from cache
        Vue.delete(state.records[entity], record_id)
    },
    [types.SET_EDITED_RECORD]: (state, { entity, record_id }) => {
        state.current_entity = entity
        state.edited_record_id = record_id
    },

    [types.SET_HOLIDAYS]: (state, { records }) => {
        state.holidays = records.map(holiday => {
            holiday.starts_at = moment(holiday.starts_at)
            holiday.ends_at = moment(holiday.ends_at)
            return holiday
        })
    },
    [types.SET_DASHBOARD_WORKLOAD]: (state, { records }) => {
        state.dashboard_workload = records
    }
}

let heartbeat = null
api.heartbeat_handler((heartbeat_data) => {
    if(heartbeat) {
        clearTimeout(heartbeat)
        heartbeat = null
    }

    if(heartbeat_data.updates) {
        Object.keys(heartbeat_data.updates).forEach(updated_entity => {
            const records = heartbeat_data.updates[updated_entity]
            mutations[types.SET_RECORDS](state, { entity: updated_entity, records })
        })
    }

    heartbeat = setTimeout(() => {
        api.heartbeat().catch((error) => {
            if(is_access_denied_error(error) === 401) mutations[types.SET_PROFILE](state, { profile: null })
        })
    }, 1000 * 15)
})

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    modules: {}
})
